module.exports = __webpack_public_path__ + "img/samandehi.e88ce97f.svg";